/**
 * Created by pandemio on 4/4/19.
 */
import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Alert} from 'reactstrap';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from "../../custom-classes/api-calls";
import FormGroupAddress from '../forms/form-group-address';
import FormGroupNewPassword from '../forms/form-group-new-password';
import FormGroupName from '../forms/form-group-name';
import FormGroupPhone from '../forms/form-group-phone';
import FormGroupUsername from '../forms/form-group-username';
import FormGroupEmail from '../forms/form-group-email';
import CheckoutForm from '../stripe/stripe-card';
import {Elements, StripeProvider} from 'react-stripe-elements';
import Settings from '../../custom-classes/settings';
import SelectorRole from '../selectors/selector-roles';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
/**
 * Modal for update a plan
 */
class ModalUpdateUserDetails extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible: this.props.visible,
            user: this.props.userId,
            showAddress: false,
            showPaymentMethod: false,
            showRolesUpdate: false,
            stripeApiKey: Settings.getStripeToken(),
            stripeUpdatePayment: true,
            subTokenStripe: null,
            proceedSubmitGeneral: false,

            mobile: false,
            userId: typeof this.props.userId !== 'undefined' && this.props.userId !== null ? this.props.userId.UserId : null,
            firstName: '',
            lastName: '',
            password: '',
            passwordRetype: '',
            username: '',
            email: '',
            phone: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
            validPassword: true,
            emailAvailable: true,
            validEmail: true,
            usernameAvailable: true,
            validUsername: true,
            validFirstName: true,
            validLastName: true,
            validPhone: true,
            validAddress: true,
            validCity: true,
            validState: true,
            validCountry: true,
            validZipCode: true,
            validRole: true,
            showModal: false, // If show the generic modal
            didMount: false, // If the component did mout
            stateRequired: false, // If the state (address) is required
            successfulTransaction: true, // If the transaction was successful or not. The default is true, so we don't show any error messages at the beggining
            loading: false, // To show or hide the loading window
            propsModal: null, // The generic data for the generic modal of messages
            showInsertionButton: true, // To hide or show the insertion button of the form,
            paymentMethodChange: false,
            passwordChange: false,
            nameChange: false,
            usernameChange: false,
            phoneChange: false,
            emailChange: false,
            roleChange: false,
            addressChange: false,
            showProfileError: false, // This is when a profile role is chosen. The profile role cannot be created here. It must be created on the subscription area.
            isEdit: typeof this.props.isEdit !== 'undefined' && this.props.isEdit !== null ? this.props.isEdit : false
        };
        this.toggle = this.toggle.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.saveAddress = this.saveAddress.bind(this);
        this.savePassword = this.savePassword.bind(this);
        this.setStripePaymentToken = this.setStripePaymentToken.bind(this);
        this.saveName = this.saveName.bind(this);
        this.savePhone = this.savePhone.bind(this);
        this.saveUsername = this.saveUsername.bind(this);
        this.savePassword = this.savePassword.bind(this);
        this.saveEmail = this.saveEmail.bind(this);
        this.saveRole = this.saveRole.bind(this);
        this.saveDetails = this.saveDetails.bind(this);
    }


    componentDidMount() {
        if (this.state.user !== null)
            this.doSearch();
    }

    evaluateUpdate(){
        if(this.state.isEdit)
        {
            this.setState({proceedSubmitGeneral: true}, ()=>{

                if(this.state.usernameChange && !this.state.validUsername)
                    this.setState({proceedSubmitGeneral: false});

                if(!this.state.proceedSubmitGeneral)
                    return null;

                if(this.state.nameChange && (!this.state.validFirstName || !this.state.validLastName))
                    this.setState({proceedSubmitGeneral: false});

                if(!this.state.proceedSubmitGeneral)
                    return null;

                if(this.state.emailChange && (!this.state.validEmail))
                    this.setState({proceedSubmitGeneral: false});

                if(!this.state.proceedSubmitGeneral)
                    return null;

                if(this.state.phoneChange && !this.state.validPhone)
                    this.setState({proceedSubmitGeneral: false});

                if(!this.state.proceedSubmitGeneral)
                    return null;

                if(this.state.addressChange && (!this.state.validAddress
                    || !this.state.validCity || !this.state.validState || !this.state.validCountry
                    || !this.state.validZipCode))
                this.setState({proceedSubmitGeneral: false});

                if(!this.state.proceedSubmitGeneral)
                    return null;

                if(this.state.roleId === Settings.CLIENT_ROLE_ID && this.state.paymentMethodChange &&
                    (this.state.subTokenStripe === null || this.state.subTokenStripe === ''))
                    this.setState({proceedSubmitGeneral: false});

                if(!this.state.proceedSubmitGeneral)
                    return null;

                if(this.state.roleChange && (this.state.roleId === null || this.state.roleId === ''))
                    this.setState({proceedSubmitGeneral: false});

                if(!this.state.proceedSubmitGeneral)
                    return null;

                if(this.state.showProfileError)
                    this.setState({proceedSubmitGeneral: false});

                return null;
            });
        }
        else // insert
        {
            if(
                this.state.validUsername && this.state.username !== null && this.state.username.trim().length > 0 &&
                this.state.validFirstName && this.state.firstName !== null && this.state.firstName.trim().length > 0 &&
                this.state.validLastName && this.state.lastName !== null && this.state.lastName.trim().length > 0 &&
                this.state.validEmail && this.state.email !== null && this.state.email.trim().length > 0 &&
                this.state.validPhone && this.state.phone !== null && this.state.phone.trim().length > 0 &&
                this.state.validAddress &&
                (
                    this.state.addressLine1 !== null && this.state.addressLine1.trim().length > 0 ||
                    this.state.addressLine2 !== null && this.state.addressLine2.trim().length > 0
                ) &&
                this.state.validCity && this.state.city !== null && this.state.city.trim().length > 0 &&
                this.state.validCountry && this.state.country !== null && this.state.country.trim().length > 0 &&
                this.state.validZipCode && this.state.zipCode !== null && this.state.zipCode.trim().length > 0
                && (
                    (this.state.validState && this.state.stateRequired) || !this.state.stateRequired)
                &&
                this.state.validPassword && this.state.password !== null && this.state.password.length > 0 &&
                this.state.passwordRetype !== null && this.state.passwordRetype.length > 0 &&
                this.state.roleId !== null && this.state.roleId.length > 0
                && !this.state.showProfileError
            )
            {
                this.setState({proceedSubmitGeneral: true});
            }
            else
            {
                this.setState({proceedSubmitGeneral: false});
            }
        }

    }

    savePhone(e) {
        this.setState({
            phone: e.phone,
            validPhone: e.validPhone,
            phoneChange: true,
        },()=>{
            this.evaluateUpdate();
        });
    }

    saveName(e) {
        this.setState({
            firstName: e.firstName,
            lastName:  e.lastName,
            validFirstName: e.validFirstName,
            validLastName:  e.validLastName,
            nameChange: true
        },()=>{
            this.evaluateUpdate();
        });
    }

    saveUsername(e) {
        this.setState({
            username: e.username,
            validUsername:  e.validUsername,
            usernameAvailable: e.usernameAvailable,
            usernameChange: true
        },()=>{
            this.evaluateUpdate();
        });
    }

    savePassword(e) {
        this.setState({
            password: e.password,
            passwordRetype:  e.passwordRetype,
            validPassword: e.validPassword,
            passwordChange: true
        },()=>{
            this.evaluateUpdate();
        });
    }

    saveEmail(e) {
        this.setState({
            email: e.email,
            emailAvailable: e.emailAvailable,
            validEmail: e.validEmail,
            emailChange: true
        },()=>{
            this.evaluateUpdate();
        });
    }

    saveRole(e){
        // The child role cannot be added here. It must be added it the subscriptions area, and attach the profile to
        // the subscription
        if(e === Settings.CLIENT_CHILD_ROLE_ID)
            this.setState({
                showProfileError: true
            });
        else
            this.setState({
                showProfileError: false
            });

        if(e === Settings.CLIENT_ROLE_ID && this.state.isEdit)
            this.setState({
                showPaymentMethod: true
            });
        else
            this.setState({
                showPaymentMethod: false
            });

        this.setState({
            roleId: e,
            roleChange: true
        },()=>{
            this.evaluateUpdate();
        });
    }

    setStripePaymentToken(e) {
        this.setState({
            subTokenStripe: e.id,
            paymentMethodChange: true
        },()=>{
            this.evaluateUpdate();
        });
    }

    saveAddress(e) {
        this.setState({
            addressLine1: e.addressLine1,
            addressLine2: e.addressLine2,
            city: e.city,
            country: e.country,
            state: e.state,
            stateRequired: e.stateRequired,
            validAddress: e.validAddress,
            validCity: e.validCity,
            validCountry: e.validCountry,
            validPhone: e.validPhone,
            validState: e.validState,
            validZipCode: e.validZipCode,
            zipCode: e.zipCode
        },()=>{
            this.evaluateUpdate();
        });
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            visible: !this.state.visible
        });
        // Updates the parent (send it owns to state to update it)
        this.props.updateParent(!this.state.visible);
    }

    /**
     * Call the results to display
     */
    doSearch() {
        this.setState({
            loading: true
        },()=>{
            let apiCallUser = ApiCalls.getUsersAdvanced(this.state.userId,
                null, null, null, null,
                null, null, null,
                null, null, null, 1,1);
            apiCallUser.then((data)=>{
                this.setState({
                    firstName: data.UserInfo[0].FullName.GivenName,
                    lastName: data.UserInfo[0].FullName.Surname,
                    password: '',
                    passwordRetype: '',
                    username: data.UserInfo[0].Username,
                    email: data.UserInfo[0].Email,
                    phone: data.UserInfo[0].Phone,
                    addressLine1: data.UserInfo[0].Address.AddressLine1,
                    addressLine2: data.UserInfo[0].Address.AddressLine2,
                    city: data.UserInfo[0].Address.City,
                    state:  data.UserInfo[0].Address.StateIsoCode === null ?
                        data.UserInfo[0].Address.State : data.UserInfo[0].Address.StateIsoCode,
                    country: data.UserInfo[0].Address.CountryIsoCode2,
                    zipCode: data.UserInfo[0].Address.Zip,
                    roleId: data.UserInfo[0].Roles[0].RoleId,
                    showPaymentMethod: data.UserInfo[0].Roles[0].RoleId === Settings.CLIENT_ROLE_ID,
                    loading: false
                });
            },()=>{
                this.setState({
                    loading: false
                })
            });
        });
    }

    /**
     * Save the details entered. Depends if the user is for update or it's a new user
     */
    saveDetails(){
        if(this.state.isEdit)
        {
            this.setState({loading:true},()=>
            {
                // Submits the registration
                let apiCall = ApiCalls.updateUserInfoByAdmin(this.state.username,
                    this.state.password,
                    this.state.passwordRetype,
                    this.state.email,
                    this.state.firstName,
                    this.state.lastName,
                    this.state.phone,
                    this.state.addressLine1,
                    this.state.addressLine2,
                    this.state.city,
                    this.state.state,
                    this.state.country,
                    this.state.zipCode,
                    this.state.country,
                    this.state.roleId,
                    this.state.subTokenStripe,
                    this.state.usernameChange,
                    this.state.passwordChange,
                    this.state.emailChange,
                    this.state.nameChange,
                    this.state.phoneChange,
                    this.state.addressChange,
                    this.state.roleChange,
                    this.state.paymentMethodChange,
                    this.state.userId
                );

                apiCall.then((returned)=>{
                    console.log("Returned", returned);

                    let message = '';
                    for(let i=0; i < returned.Messages.length;i++)
                    {
                        message += returned.Messages[i] + '<br/>';
                    }

                    let propsModal = {
                        bodyText: message,
                        visible: true
                    };

                    if(returned.TransactionValid) {
                        this.setState({
                            propsModal: propsModal,
                            showModal: true,
                            loading: false
                        });
                    }
                    else{
                        this.setState({
                            loading: false
                        });
                    }
                    this.props.updateParent(this.state);
                    return this.state;
                });
            });
        }
        else
        {
            this.setState({loading:true},()=>
            {

                // Submits the registration
                let apiCall = ApiCalls.registerUserByAdmin(this.state.username, this.state.password, this.state.passwordRetype,
                    this.state.email, this.state.firstName, this.state.lastName, this.state.phone, this.state.addressLine1,
                    this.state.addressLine2,
                    this.state.city, this.state.state, this.state.country, this.state.zipCode,
                    this.state.country,
                    this.state.roleId);
                apiCall.then((returned)=>{
                    let propsModal = {
                        bodyText: returned.Messages[0],
                        visible: true
                    };

                    if(returned.TransactionValid) {
                        if (returned.UserId !== null)
                            this.setState({
                                propsModal: propsModal,
                                showModal: true,
                                loading: false
                            });

                    }
                    this.props.updateParent(this.state);
                    return this.state;
                });
            });
            this.setState({
                loading: false
            });
        }
    }

    /**
     * Renders the generic modal
     * @returns {XML}
     */
    renderGenericModal(){
        return (
            <ModalGeneric data={this.state.propsModal}
                          updateParent={this.toggleAlertModal}/>
        );
    }

    /**
     * Toggles alert modal (alert from registration)
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }

    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Modal isOpen={this.state.visible} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h2><Translate id="user-management.general-details"/></h2>
                            </Col>
                            <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <FormGroupName disabled={this.state.disabledName}
                                               data={this.state} updateParent={this.saveName}/>
                                <FormGroupPhone disabled={this.state.disabledPhoneNumber}
                                                data={this.state} updateParent={this.savePhone}/>
                            </Col>
                            <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <FormGroupUsername disabled={this.state.disabledUsername} data={this.state}
                                                   updateParent={this.saveUsername}/>
                                <FormGroupNewPassword disabled={this.state.disabledPassword} data={this.state}
                                                      updateParent={this.savePassword}/>
                                <FormGroupEmail disabled={this.state.disabledEmail} data={this.state}
                                                updateParent={this.saveEmail}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h2><Translate id="user-management.role"/></h2>
                            </Col>
                            <Col sm={{size: 12, offset: 0}} md={{size: 12}} lg={{size: 12}}>
                                <SelectorRole roleId={this.state.roleId} updateParent={this.saveRole} />
                            </Col>
                            <Alert color="danger" isOpen={this.state.showProfileError}>
                                <Translate id="user-management.profiles-error"/>
                            </Alert>
                        </Row>
                        <Row>
                            <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h2><Translate id="user-management.address"/></h2>
                            </Col>
                            <Col sm={{size: 12, offset: 0}} md={{size: 12}} lg={{size: 12}}>
                                <FormGroupAddress data={this.state} updateParent={this.saveAddress}/>
                            </Col>
                        </Row>
                        {this.state.showPaymentMethod ?
                        <Row>
                            <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h2><Translate id="user-management.payment-method"/></h2>
                            </Col>
                            <Col sm={{size: 12, offset: 0}} md={{size: 12}} lg={{size: 12}}>
                                <StripeProvider apiKey={this.state.stripeApiKey}>
                                    <Elements>
                                        <CheckoutForm data={this.state.stripeUpdatePayment}
                                                      updateParent={this.setStripePaymentToken}/>
                                    </Elements>
                                </StripeProvider>
                            </Col>
                        </Row> : null
                        }

                    </ModalBody>
                    <ModalFooter>
                        <Button color="success"
                                disabled={!this.state.proceedSubmitGeneral}
                                onClick={this.saveDetails}>
                            <Translate id="general.submit"/>
                        </Button>
                    </ModalFooter>
                </Modal>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ? this.renderGenericModal() : null}
            </div>
        );
    }
}

export default ModalUpdateUserDetails;